<div>
	<h2 class="compliance-header text-center">
		RegScale is purposefully <br />
		designed to be different.
	</h2>
	<div class="compliance-container">
		<div class="compliance-container-inner">
			<img
				class="d-none d-md-block orange-pattern-overlay"
				src="../../assets/img/orange-pattern.png"
				alt=""
			/>
			<img
				class="d-md-none orange-pattern-overlay"
				src="../../assets/img/orange-pattern-mobile.png"
				alt=""
			/>
			<div class="container text-center">
				<div class="row">
					<div class="col-md-4 mb-5 mb-lg-0">
						<img
							class="challenges-list-img"
							src="../../assets/img/api-centered.svg"
							alt=""
						/>
						<div class="challenges-list-head">API Centered</div>
						<div class="challenges-list-content">
							Deliver optimal value from your existing
							<br class="d-none d-xl-block" />
							security and compliance investments
							<br class="d-none d-xl-block" />
							by integrating them all with our open
							<br class="d-none d-xl-block" />
							APIs with no vendor lock-in.
						</div>
					</div>
					<div class="col-md-4 mb-5 mb-lg-0">
						<img
							class="challenges-list-img"
							src="../../assets/img/universally-deployable.svg"
							alt=""
						/>
						<div class="challenges-list-head">
							Universally Deployable
						</div>
						<div class="challenges-list-content">
							Deploy in your environment or ours based on your
							<br class="d-none d-xl-block" />
							business needs, delivering maximum
							<br class="d-none d-xl-block" />
							flexibility and scale as your compliance
							<br class="d-none d-xl-block" />
							requirements evolve.
						</div>
					</div>
					<div class="col-md-4 mb-5 mb-lg-0">
						<img
							class="challenges-list-img"
							src="../../assets/img/infinitely-portable.svg"
							alt=""
						/>
						<div class="challenges-list-head">
							Infinitely Portable
						</div>
						<div class="challenges-list-content">
							Install anywhere and share data 
							<br class="d-none d-xl-block" />
							across tools using OSCAL as
							<br class="d-none d-xl-block" />
							your organization's needs evolve.
						</div>
					</div>
				</div>
				<a href="https://go.regscale.com/RegScale-Create-Account">
					<button class="complaince-button py-2 px-5 mt-2 mt-lg-5">
						See For Yourself
					</button></a
				>
			</div>
		</div>
	</div>
</div>
